// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__SSI_A","inner":"Footer_inner__1IJy0","nextIcon":"Footer_nextIcon__3zQoN","innerLeft":"Footer_innerLeft__X8gGg"};